<template>
  <div class="animated fadeIn">
    <div class="row" v-if="globals.groupId != 4">
      <div class="col-sm-12">
        <userform v-bind:title="$t('NEWUSER')" v-bind:formData="formData" v-bind:formError="formError" v-bind:aclGroups="aclGroups" v-bind:status="status" v-on:saveRow="saveRow"></userform>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
            <div class="card-header">
              <i class="fa fa-align-justify"></i> {{$t('USERS')}}
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-3">
                  <b-form-fieldset v-bind:label="$t('SEARCH')">
                    <b-form-input v-model="pagination.query"></b-form-input>
                  </b-form-fieldset>
                </div>
              </div>
            </div>
            <div class="card-body" v-if="typeof data.root == 'undefined' || !data.root.length">
              <p class="center">{{$t('NODATAFOUND')}}</p>
            </div>
            <div class="card-body" v-if="typeof data.root != 'undefined' && data.root.length">
              <table class="table table-responsive-sm table-striped">
                <thead>
                  <tr>
                    <th>{{$t('ID')}}</th>
                    <th>{{$t('USERNAME')}}</th>
                    <th>{{$t('USEREMAIL')}}</th>
                    <th>{{$t('NAME')}}</th>
                    <th>{{$t('SURNAME')}}</th>
                    <th>{{$t('COMPANYNAME')}}</th>
                    <th>{{$t('SAVE')}}</th>
                    <th>{{$t('DELETE')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in data.root">
                    <tr>
                      <td>{{item.userId}}</td>
                      <td>{{item.username}}</td>
                      <td>{{item.userEmail}}</td>
                      <td>{{item.name}}</td>
                      <td>{{item.surname}}</td>
                      <td>{{item.companyName}}</td>
                      <td><b-button type="reset" size="sm" variant="primary" v-on:click.prevent="item.trhidden = !item.trhidden"><icon name="save"></icon> {{$t('EDIT')}}</b-button></td>
                      <td><b-button type="reset" size="sm" variant="danger" v-on:click.prevent="deleteRow(item.userId)"><icon name="ban"></icon> {{$t('DELETE')}}</b-button></td>
                    </tr>
                    <tr v-if="item.trhidden">
                      <td colspan="8">
                        <userform v-bind:title="$t('EDITUSER')+' '+item.username" v-bind:formData="item" v-bind:formError="formError" v-bind:aclGroups="aclGroups" v-on:saveRow="saveRow" v-bind:status="status"></userform>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <nav>
                <b-pagination align="center" :total-rows="parseInt(data.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>
              </nav>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import Api from '@/api/admin/Users';
import AclGroupsApi from '@/api/admin/AclGroups';
import UsersForm from './UsersForm.vue';

export default {
    name: 'Users',
    components:
  {
      userform: UsersForm,
  },
    data()
    {
        const me = this;
        return {
            data: {},
            aclGroups: {},
            formError: {},
            formData:
      {
          username: '',
          password: '',
          userEmail: '',
          userGroup: 4,
          status: 'active',
          name: '',
          surname: '',
          address: '',
          city: '',
          postalCode: '',
          country: '',
          phone: '',
          oibNum: '',
          authToken: null,
      },
            status:
      [
          {
              value: 'active',
              text: me.$i18n.t('ACTIVE'),
          },
          {
              value: 'inactive',
              text: me.$i18n.t('INACTIVE'),
          },
      ],
            pagination:
      {
          query: '',
          currentPage: 1,
          limit: 20,
          searchTimeout: false,
      },
        };
    },
    created()
    {
        const me = this;
        me.getData();
        me.getAclGroups();
    },
    methods:
  {
      getAclGroups()
      {
          const me = this;
          AclGroupsApi.selectRow(me.getGroupParams, function (data)
          {
              if (data.error && data.error == true)
              {
                  Vue.$notify.error(data.notice);
                  return;
              }
              me.aclGroups = data;
          });
      },
      saveRow(item)
      {
          const me = this;

          if (typeof item.userId !== 'undefined')
          {
              item.id = item.userId;
              delete (item.userId);
          }

          Api.save(item, function (val)
          {
              if (val.error)
              {
                  me.$notify.notice(val);
                  me.formError = val;
              }
              else
              {
                  me.$notify.notice(val);
                  me.formError = {};
                  me.getData();
              }
          });
      },
      getData()
      {
          const me = this;
          Api.selectRow(me.getParams, function (data)
          {
              if (data.error && data.error == true)
              {
                  me.$notify.notice(data);
                  return;
              }

              for (let i = 0; i < data.root.length; i++)
              {
                  data.root[i].trhidden = false;
                  data.root[i].password = '';
              }

              me.data = data;
          });
      },
      deleteRow(id)
      {
          const me = this;
          me.$store.commit('setModalAlert',
              {
                  text: me.$i18n.t('AREYOUSHURE'),
                  btnAction()
                  {
                      Api.deleteRow({ id }, function (data)
                      {
                          if (data.error && data.error == true)
                          {
                              me.$notify.error(data.notice);
                          }
                          else
                          {
                              me.$notify.success(data.notice);
                          }
                          me.getData();
                      });
                  },
              });
      },
  },
    watch:
  {
      'pagination.currentPage'(val)
      {
          const me = this;
          me.getData();
      },
      'pagination.query'(val)
      {
          const me = this;

          if (me.pagination.searchTimeout != false)
          {
              clearTimeout(me.pagination.searchTimeout);
          }

          me.pagination.searchTimeout = setTimeout(function ()
          {
              me.getData();
              me.pagination.searchTimeout = false;
          }, 300);
      },
  },
    computed:
  {
      ...mapGetters([
          'globals',
      ]),
      getParams()
      {
          const me = this;
          const data = { ...me.pagination };
          data.start = (data.currentPage - 1) * data.limit;
          return data;
      },
  },
};
</script>
